import type { Metadata } from "next";
import { Poppins } from "next/font/google";
import "./globals.css";
import { LenisProvider } from "@/components/providers/LenisProvider";
import ClientLayoutWrapper from "./ClientLayoutWrapper";
import GlobalFloating from '@/components/ButtonFloat/GlobalFloating';

const poppins = Poppins({
  subsets: ["latin"],
  variable: "--font-poppins",
  weight: ["300", "400", "500", "600", "700"],
});

export const metadata: Metadata = {
  title: "FOUNDRY ARCHITECTURE - Premium Collections",
  description:
    "Immersive exploration UI/UX build with modern Next.js framework.",
  openGraph: {
    title: "FOUNDRY ARCHITECTURE",
    description: "Immersive exploration UI/UX platform.",
    type: "website",
  },
};

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <html
      lang="en"
      className={`${poppins.variable} antialiased selection:bg-white selection:text-black`}
    >
      <body className="bg-[#0a0a0a] text-white overflow-x-hidden w-full font-sans">
        <LenisProvider>
          <ClientLayoutWrapper>
            {children}
            <GlobalFloating />
          </ClientLayoutWrapper>
        </LenisProvider>
      </body>
    </html>
  );
}